import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AvailableUserForStaff {
  id: string;
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  avatar_url?: string;
}

export const useAvailableUsersForStaff = () => {
  return useQuery({
    queryKey: ["available-users-for-staff"],
    queryFn: async () => {
      console.log("Fetching available users for staff creation...");
      
      // First get all staff user_ids
      const { data: staffUsers, error: staffError } = await supabase
        .from('crm_staff')
        .select('user_id')
        .not('user_id', 'is', null);
      
      if (staffError) {
        console.error("Error fetching staff users:", staffError);
        throw staffError;
      }
      
      const staffUserIds = staffUsers?.map(s => s.user_id).filter(Boolean) || [];
      console.log("Staff user IDs to exclude:", staffUserIds);
      
      // Get users who are authenticated but not yet staff
      let query = supabase
        .from('profiles')
        .select('id, user_id, first_name, last_name, email, phone, avatar_url')
        .not('user_id', 'is', null); // Must be authenticated users
      
      // Exclude existing staff if there are any
      if (staffUserIds.length > 0) {
        query = query.not('user_id', 'in', `(${staffUserIds.join(',')})`);
      }
      
      const { data, error } = await query.order('first_name', { ascending: true });
      
      if (error) {
        console.error("Error fetching available users for staff:", error);
        throw error;
      }
      
      console.log("Available users for staff found:", data?.length || 0);
      return (data as AvailableUserForStaff[]) || [];
    }
  });
};